export const getTimeStamp = async () => {
  let timestamp;
  try {
    const resp: any = await fetch(
      `https://hedera.staderlabs.com/api/timestamp`
    );
    const response: any = await resp.json();
    if (response?.timestamp) {
      timestamp = response.timestamp;
    }
  } catch (e) {
    timestamp = Math.floor(new Date().getTime() / 1000);
  }
  return timestamp;
};
